/**
 * Icônes réseaux sociaux (même style que la modal « Partage et gagne »).
 */

/** Logo officiel Facebook (tracé Simple Icons) sur pastille ronde à la couleur de marque. */
export const FacebookIcon = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="24" fill="#0866FF" />
    <path
      d="M30.2 24.6h-4.1v13H21v-13h-2.9v-4.4H21v-2.6c0-3.7 1.5-5.9 5.9-5.9h3.6v4.4h-2.2c-1.7 0-1.8.6-1.8 1.8v2.3h4.1l-.4 4.4z"
      fill="white"
    />
  </svg>
);

/** Logo officiel WhatsApp (tracé Simple Icons, 24×24) recentré dans la pastille 48×48. */
export const WhatsAppIcon = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="24" fill="#25D366" />
    <path
      transform="translate(9 9) scale(1.25)"
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.148.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"
      fill="white"
    />
  </svg>
);

export const MessengerIcon = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="24" fill="#0084FF" />
    <path
      d="M24 8C15.2 8 8 14.7 8 23c0 4.5 1.9 8.5 5 11.3V40l5-2.7c1.6.4 3.3.7 5 .7 8.8 0 16-6.7 16-15S32.8 8 24 8zm1.6 20.2l-4-4.3-7.9 4.3 8.7-9.2 4.1 4.3 7.8-4.3-8.7 9.2z"
      fill="white"
    />
  </svg>
);

export const InstagramIcon = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <defs>
      <radialGradient id="ig-brand-grad" cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#fdf497" />
        <stop offset="5%" stopColor="#fdf497" />
        <stop offset="45%" stopColor="#fd5949" />
        <stop offset="60%" stopColor="#d6249f" />
        <stop offset="90%" stopColor="#285AEB" />
      </radialGradient>
    </defs>
    <rect width="48" height="48" rx="12" fill="url(#ig-brand-grad)" />
    <rect x="14" y="14" width="20" height="20" rx="5" stroke="white" strokeWidth="2.5" fill="none" />
    <circle cx="24" cy="24" r="5" stroke="white" strokeWidth="2.5" fill="none" />
    <circle cx="30.5" cy="17.5" r="1.5" fill="white" />
  </svg>
);

/**
 * WhatsApp Business — bulle de conversation + « B » (logo officiel de
 * l'app, vérifié sur Wikimedia Commons puis sur l'asset fourni directement).
 * Tracé SVG, pas un PNG : un raster à résolution fixe reste flou/mou aux
 * petites tailles (16-24px, boutons inline), quel que soit le luminance-fill
 * utilisé pour le détourer — un défaut inhérent à la finesse du contour de
 * bulle, pas une histoire de qualité de détourage.
 */
export const WhatsAppBusinessIcon = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="24" fill="#25D366" />
    <path
      d="M24 9.5c-7.7 0-14 6-14 13.4 0 2.6.8 5.1 2.2 7.2L10.5 38l7.9-2.4c1.7.7 3.6 1.1 5.6 1.1 7.7 0 14-6 14-13.4s-6.3-13.8-14-13.8z"
      fill="none"
      stroke="white"
      strokeWidth="3.2"
      strokeLinejoin="round"
    />
    <text
      x="24"
      y="28"
      textAnchor="middle"
      fill="white"
      fontSize="15"
      fontWeight="700"
      fontFamily="Arial, Helvetica, sans-serif"
    >
      B
    </text>
  </svg>
);

/** TikTok — même format circulaire que WhatsApp / Facebook */
export const TikTokIcon = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="24" fill="#010101" />
    <path
      d="M31.8 18.2c-1.7-.2-3.2-.9-4.4-2v10.2c0 3.8-3.1 6.9-6.9 6.9s-6.9-3.1-6.9-6.9 3.1-6.9 6.9-6.9c.4 0 .7 0 1.1.1v3.5c-.3-.1-.7-.2-1.1-.2-1.9 0-3.4 1.5-3.4 3.5s1.5 3.5 3.4 3.5 3.4-1.5 3.4-3.5V12.5h3.5c.2 2.1 1.5 3.9 3.3 4.8 1 .5 2.1.7 3.2.7v3.5c-.6 0-1.2-.1-1.7-.3z"
      fill="white"
    />
  </svg>
);
